/**
 * Converte string de intervalo para milissegundos
 * Formatos suportados: "00:20:10", "1.03:13:20" (dias.horas:minutos:segundos)
 * @param {string} intervalStr 
 * @returns {number} milissegundos
 */
export const parseIntervalToMs = (intervalStr) => {
    if (!!!intervalStr) return 0;

    let days = 0;
    let timePart = intervalStr;

    // Verifica se tem dias no formato "D.HH:MM:SS"
    const dayMatch = intervalStr.match(/^(\d+)\./);
    if (dayMatch) {
        days = parseInt(dayMatch[1], 10);
        timePart = intervalStr.substring(dayMatch[0].length);
    }

    // Parse do tempo HH:MM:SS
    const timeParts = timePart.split(':').map(Number);
    const hours = timeParts[0] || 0;
    const minutes = timeParts[1] || 0;
    const seconds = timeParts[2] || 0;

    return ((days * 24 + hours) * 3600 + minutes * 60 + seconds) * 1000;
};

/**
 * Formata string de intervalo para texto legível
 * Ex: "1.03:13:20" -> "27:13:20" (dias convertidos em horas)
 * Ex: "00:05:30" -> "00:05:30"
 * @param {string} intervalStr 
 * @returns {string} texto formatado no padrão "HH:mm:ss" (com horas acumuladas)
 */
export const formatIntervalToReadable = (intervalStr) => {
    if (!intervalStr) return '';

    const ms = parseIntervalToMs(intervalStr);
    const totalSeconds = Math.floor(ms / 1000);

    const totalHours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${totalHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Formata milissegundos para string com horas totais (sem dias)
 * Ex: 3d 18:05:35 -> 90:05:35
 * @param {number} ms 
 * @returns {string}
 */
export const formatTime = (ms) => {
    if (ms < 0) ms = 0;

    const totalSeconds = Math.floor(ms / 1000);
    const totalHours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${totalHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};